import { AgreementFuelCard } from "./agreement-fuel-card.model";
import { CarInfoModel } from "./car-info.model";

export class CompanyCarDetail extends CarInfoModel {

    constructor(jsonObject: any = null) {
      super(jsonObject);
  
      if (jsonObject == null) {
        return;
      }
  
      this.code1 = jsonObject.code1;
      this.code2 = jsonObject.code2;  
      this.costCenterId = jsonObject.costCenterId;
      this.costCenterText = jsonObject.costCenterText?.trimEnd();
      this.partId = jsonObject.partId;
  
      this.agreementFuelCardFormats = jsonObject.agreementFuelCardFormats?.map((agreementFuelCard: any) => new AgreementFuelCard(agreementFuelCard)) ?? [];
      
      this.agreementTypeNames = jsonObject.agreementTypeNames ?? [];      
    }
  
    agreementFuelCardFormats: AgreementFuelCard[];
    agreementTypeNames: string[];
    code1:string;
    code2: string;  
    costCenterId: number | null;
    costCenterText: string;
    grossBenefitValue: number | null;
    reducedBenefitValue: boolean;
    extras: string[];    
    startMileage: number | null;
    endMileage: number | null;
    yearlyAgreedMileage: number | null;
    accountResidualValue: number;
    partId: number;
  }
